export const getEngagementRateBadge = (rate, defaultColor = 'rgba(255, 255, 255, 0.6)') => {
    const num = Number(rate);
    if (!Number.isFinite(num) || num <= 0) return null;
    const percent = num * 100;
    const formattedPercent = `${percent.toFixed(1)}% ER`;

    // Tier 4: Exceptional / Viral (>= 10%)
    if (num >= 0.10) {
        return {
            label: formattedPercent,
            icon: '🔥',
            color: '#ef4444',
            backgroundColor: 'rgba(239, 68, 68, 0.2)',
            tier: 'viral',
            title: `Exceptional engagement: ${percent.toFixed(1)}% (Viral, top tier)`
        };
    }

    // Tier 3: High / Strong Performer (5% - 10%)
    if (num >= 0.05) {
        return {
            label: formattedPercent,
            icon: '⚡',
            color: '#f59e0b',
            backgroundColor: 'rgba(245, 158, 11, 0.2)',
            tier: 'high',
            title: `High engagement: ${percent.toFixed(1)}% (Strong performer)`
        };
    }

    // Tier 2: Good / Average (2% - 5%)
    if (num >= 0.02) {
        return {
            label: formattedPercent,
            icon: '✦',
            color: '#38bdf8',
            backgroundColor: 'rgba(56, 189, 248, 0.16)',
            tier: 'good',
            title: `Good engagement: ${percent.toFixed(1)}% (Above baseline)`
        };
    }

    // Tier 1: Standard (< 2%)
    return {
        label: formattedPercent,
        icon: '',
        color: defaultColor,
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        tier: 'standard',
        title: `Standard engagement: ${percent.toFixed(1)}%`
    };
};
